// extracted by mini-css-extract-plugin
export default {"pageFooter":"PageFooter_pageFooter__F7Jq9","socialLinks":"PageFooter_socialLinks__8R-h0","copyright":"PageFooter_copyright__uyi7i"};